import {
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Input,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import DonutChart from "../../components/charts/DonutChart";
import Layout from "../../components/layout/Layout";
import {
  addPlaylistToScreen,
  screenFlagOff,
  uncheckAssignedScreen,
} from "../../Redux/Actions/screenAction";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import "./setting.css";
import { ReactComponent as ScreenIcon } from "../../Assets/images/screenIcon.svg";
import { ReactComponent as UserProfileIcon } from "../../Assets/images/userprofileIcon.svg";
import { ReactComponent as MobileImage } from "../../Assets/images/mobileImage.svg";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { TextareaAutosize } from "@material-ui/core";
import { playlistFlagOff } from "../../Redux/Actions/playlistAction";
function Setting({ user, socketRef }) {
  const navigate=useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const { screens, isUnChecked } = useSelector((state) => state.Screen);
  const { playlist } = useSelector((state) => state.Playlist);
  const [playlistInfo, setPlaylistInfo] = useState({});
  const [code, setCode] = useState("");
  const [openModel, setOpenModel] = useState(false);
  const [message, setMessage] = useState("");
  const [duration, setDuration] = useState(60);
  const [playlistSearch, setPlaylistSearch] = useState("");
  
  // Filtered screen list navigation (from sessionStorage)
  const carouselIds = (() => {
    try { return JSON.parse(sessionStorage.getItem('screenSettingCarouselIds') || '[]'); } catch { return []; }
  })();
  const currentIdx = carouselIds.indexOf(params.id);
  const prevId = currentIdx > 0 ? carouselIds[currentIdx - 1] : null;
  const nextId = currentIdx < carouselIds.length - 1 ? carouselIds[currentIdx + 1] : null;
  const goToPrev = () => prevId && navigate("/setting/" + prevId);
  const goToNext = () => nextId && navigate("/setting/" + nextId);
  useEffect(() => {
    setPlaylistInfo({
      ...screens.find((s) => s._id === params.id),
      screenAssigned: false,
    });
  }, [params.id]);
  useEffect(() => {
    if (isUnChecked) {
      setPlaylistInfo({ ...screens.find((s) => s._id === params.id) });
      dispatch(screenFlagOff());
    }
  }, [isUnChecked]);
  useEffect(()=>{
    socketRef.current.emit('leaving--connection')
    socketRef.current.on('screen--connection--off',(obj)=>{
    //  console.log(obj)
    })
  },[])
  const submit = () => {
    socketRef?.current.emit("message", {
      message,
      duration,
      mac: playlistInfo.mac,
    });
    setOpenModel(false);
    setMessage("");
  };
  const emitAssignPlaylistToScreen = (c) => {
    const id = setTimeout(() => {
      const screen = screens.find((s) => s._id === c);
      // console.log(screen);
      if (screen) {
        socketRef.current?.emit("playlist_added", {
          detail: { mac: screen?.mac, code: c },
        });
        clearTimeout(id);
      }
    }, 2000);
  };
  const screenHanlderSelect = (e) => {
    setCode(e.target.value);
    // console.log(e.target.value);
    dispatch(addPlaylistToScreen({ id: params.id, value: e.target.value }));
    // setPlaylistInfo({...screens.find(s=>s._id===params.id),screenAssigned:true})
    emitAssignPlaylistToScreen(params.id);
  };
  return (
    <>
    {/* {
      console.log(playlistInfo)
    } */}
      <Layout title={"Setting"} user={user}>
        {/* Prev / Next screen navigation */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 3, pt: 1.5, pb: 0.5 }}>
          <button
            onClick={goToPrev}
            disabled={!prevId}
            style={{
              display: 'flex', alignItems: 'center', gap: 4,
              background: prevId ? '#551FFF' : '#e0e0e0',
              color: 'white', border: 'none', borderRadius: 8,
              padding: '6px 14px', cursor: prevId ? 'pointer' : 'not-allowed',
              fontSize: 13, fontWeight: 600, opacity: prevId ? 1 : 0.5,
            }}
          >
            <ChevronLeftIcon style={{ fontSize: 18 }} /> 이전
          </button>
          <span style={{ fontSize: 12, color: '#888', minWidth: 80, textAlign: 'center' }}>
            {carouselIds.length > 0 ? (currentIdx + 1) + " / " + carouselIds.length : ""}
          </span>
          <button
            onClick={goToNext}
            disabled={!nextId}
            style={{
              display: 'flex', alignItems: 'center', gap: 4,
              background: nextId ? '#551FFF' : '#e0e0e0',
              color: 'white', border: 'none', borderRadius: 8,
              padding: '6px 14px', cursor: nextId ? 'pointer' : 'not-allowed',
              fontSize: 13, fontWeight: 600, opacity: nextId ? 1 : 0.5,
            }}
          >
            다음 <ChevronRightIcon style={{ fontSize: 18 }} />
          </button>
        </Box>
        <Grid container>
          <Grid item lg={8}>
            <Box
              sx={{
                background: "white",
                p: 2,
                margin: "18px 20px",
                borderRadius: "16px",
              }}
            >
              <div className="device flex flex-column">
                <div className="device-header flex flex-content-space-around alignItemCenter">
                  <div className="device-header-left flex">
                    <div className="screen-icon flex justifyContentCenter alignItemCenter">
                      <img src={"/images/MobileScreen.png"} />
                    </div>
                    <div className="screen-text flex flex-column">
                      <p>{playlistInfo?.device_details?.device_name}</p>
                      {
                        playlistInfo.status ? <span>Connected</span> : <span>Disconnected</span>
                      }
                      
                    </div>
                  </div>
                  <div className="device-header-right flex">
                  <Box
                      sx={{
                        display: "flex",
                        gap: "5px",
                        padding: "20px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                        <ScreenIcon
                          style={{ color: "#6179FB" }}
                          onClick={() =>
                           navigate(`/sharing/${playlistInfo?.mac}`) 
                          }
                        />
                    </Box>
                    <div className="playlist-selector flex flex-column justifyContentCenter alignItemCenter">
                      {playlistInfo?.playlist === undefined ||
                      playlistInfo?.screenAssigned ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: 8, margin: "0 4px", width: "280px" }}>
                          <input
                            type="text"
                            placeholder="플레이리스트 검색..."
                            value={playlistSearch}
                            onChange={e => setPlaylistSearch(e.target.value)}
                            style={{ height: 38, border: "1px solid rgba(85,31,255,0.4)", borderRadius: 6, padding: "0 12px", fontSize: 14, outline: "none", width: "100%", boxSizing: "border-box" }}
                          />
                          <select
                            className="deviceSelect"
                            value={code}
                            onChange={screenHanlderSelect}
                            size={Math.min(10, ([...(playlist||[])].filter(p => p.name?.toLowerCase().includes(playlistSearch.toLowerCase())).length || 1) + 1)}
                            style={{
                              width: "100%",
                              background: "rgba(217, 217, 217, 0.3)",
                              border: "1px solid rgba(85, 31, 255, 0.2)",
                              color: "black",
                              borderRadius: "6px",
                              fontSize: 14,
                              padding: "4px 0",
                            }}
                          >
                            <option value="">select Device</option>
                            {playlist &&
                              [...playlist]
                                .filter(p => p.name?.toLowerCase().includes(playlistSearch.toLowerCase()))
                                .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0))
                                .map((play) => (
                                  <option key={play._id} value={play._id}>{play.name}</option>
                                ))}
                          </select>
                        </div>
                      ) : (
                        <Box
                          sx={{
                            display: "flex",
                            gap: "5px",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <p>{playlistInfo?.playlist?.name}</p>
                          <BorderColorIcon
                            style={{ color: "#6179FB" }}
                            onClick={() =>
                              dispatch(uncheckAssignedScreen(playlistInfo._id))
                            }
                          />
                        </Box>
                      )}
                    </div>
                  </div>
                </div>
                <Grid container>
                  <Grid item lg={8}>
                    <Grid
                      container
                      sx={{
                        borderBottom: "1px solid rgba(85, 31, 255, 0.2)",
                        pt: 2.5,
                        pb: 2.5,
                      }}
                    >
                      <Grid item lg={6}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            pl: 7,
                          }}
                        >
                          <div className="info-1">
                            <p>Code</p>
                            <span>{playlistInfo.code}</span>
                          </div>
                          <div className="info-2">
                            <p>Device Name</p>
                            <span>
                              {playlistInfo?.device_details?.device_name}
                            </span>
                          </div>
                        </Box>
                      </Grid>
                      <Grid item lg={6}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            pl: 7,
                          }}
                        >
                          <div className="info-1">
                            <p>Name</p>
                            <span>{playlistInfo.name}</span>
                          </div>
                          <div className="info-2">
                            <p>Manufacturing</p>
                            <span>
                              {playlistInfo?.device_details?.manufacturer}
                            </span>
                          </div>
                        </Box>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      sx={{
                        borderBottom: "1px solid rgba(85, 31, 255, 0.2)",
                        pt: 2.5,
                        pb: 2.5,
                      }}
                    >
                      <Grid item lg={6}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            ml: 7,
                          }}
                        >
                          <div className="info-1">
                            <p>OS</p>
                            <span>
                              {playlistInfo?.device_details?.os_version}
                            </span>
                          </div>
                          <div className="info-2">
                            <p>Location</p>
                            <span>United State</span>
                          </div>
                        </Box>
                      </Grid>
                      <Grid item lg={6}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            ml: 7,
                          }}
                        >
                          <div className="info-1">
                            <p>Mac Address</p>
                            <span>{playlistInfo.mac}</span>
                          </div>
                          <div className="info-2">
                            <p>Ip Address</p>
                            <span>{playlistInfo?.device_details?.ip}</span>
                          </div>
                        </Box>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      sx={{
                        pt: 2.5,
                        pb: 2.5,
                      }}
                    >
                      <Grid item lg={6}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            ml: 7,
                          }}
                        >
                          <div className="info-1">
                            <p>Software</p>
                            <span>
                              {playlistInfo?.device_details?.software}
                            </span>
                          </div>
                        </Box>
                      </Grid>
                      <Grid item lg={6}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            ml: 7,
                          }}
                        >
                          <div className="info-1">
                            <p>Root Level</p>
                            <span>
                              {playlistInfo?.device_details?.root_level}
                            </span>
                          </div>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={4}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        color: "#15192C",
                        fontSize: "18px",
                        py: 3,
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        Device Details
                      </Typography>
                    </Box>
                    <Box>
                      <div className="ram">
                        <DonutChart
                        views={'Ram'}
                          series={[
                            +playlistInfo?.ram?.total.split(" ")[0] - (+playlistInfo?.ram?.free.split(" ")[0]),
                            +playlistInfo?.ram?.free.split(" ")[0],
                          ]}
                          labels={[
                            `Usage ${playlistInfo?.ram?.total.split(" ")[1]}`,
                            `Free ${playlistInfo?.ram?.free.split(" ")[1]}`,
                          ]}
                        />
                      </div>
                    </Box>
                    <Box>
                      <div className="storage">
                        <DonutChart
                        views={'Storage'}
                         series={[
                          +playlistInfo?.storage?.total.split(" ")[0] - (+playlistInfo?.storage?.free.split(" ")[0]),
                          +playlistInfo?.storage?.free.split(" ")[0],
                        ]}
                        labels={[
                          `Usage ${playlistInfo?.storage?.total.split(" ")[1]}`,
                          `Free ${playlistInfo?.storage?.free.split(" ")[1]}`,
                        ]}
                        />
                      </div>
                    </Box>
                  </Grid>
                </Grid>
              </div>
            </Box>
          </Grid>
          <Grid item lg={4}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#551FFF",
                padding: "15px 20px",
                color: "white",
                margin: "15px",
                borderRadius: "6px",
              }}
            >
              <UserProfileIcon />
              <Typography
                sx={{
                  fontSize: "12px",
                  pl: 1,
                }}
              >
                User profile settings
              </Typography>
            </Box>
            <Box
              sx={{
                background: "white",
                p: 2,
                margin: "18px 20px",
                borderRadius: "16px",
              }}
            >
              <MobileImage />
              <Box>
                <Typography
                  sx={{
                    color: "#15192C",
                    fontSize: "16px",
                    fontWeight: "bold",
                    mt: 3,
                  }}
                >
                  Detail:
                </Typography>
                <Typography
                  sx={{
                    color: "#92959E",
                    fontSize: "15px",
                  }}
                >
                  Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum
                  Lorem Ipsum Lorem Ipsum Lorem Ipsum
                </Typography>
                <Button
                  variant={"outlined"}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "15px 20px",
                    color: "#551FFF",
                    margin: "15px",
                    borderRadius: "6px",
                    border: " 1px solid #551FFF",
                    mt: 3,
                    fontSize: "15px",
                    pl: 1,
                    width: "300px",
                    textTransform: "capitalize",
                  }}
                  onClick={() => setOpenModel(true)}
                >
                  Send Message
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Layout>

      <Dialog
        // maxWidth={"xl"}
        fullWidth={true}
        open={openModel}
        onClose={() => setOpenModel(false)}
      >
        <DialogTitle
          style={{
            textAlign: "center",
            borderBottom: "2px solid #551fff",
            fontSize: "18px",
            fontWeight: 700,
          }}
        >
          Send Message
        </DialogTitle>
        <DialogContent>
          <div className="screen-form">
            <div className="icon-screen">
              {/* <AddScreenIcon /> */}
              <MailOutlineIcon
                sx={{ color: "#551fff", height: "50px", width: "50px" }}
              />
            </div>
            <div className="form-fields">
              <TextField
                type={"text"}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                variant={"outlined"}
                label={"Write Message"}
                multiline
                fullWidth
              />
            </div>

            <div className="form-fields">
              <TextField
                type={"number"}
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
                sx={{
                  width: "100px",
                }}
              />
            </div>

            <Box
              sx={{
                display: "flex",
                mt: 8,
                mb: 5,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <button
                style={{
                  background: "white",
                  padding: "8px",
                  width: "130px",
                  color: "#551FFF",
                  border: "1px solid #551FFF",
                  marginRight: "10px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={() => setOpenModel(false)}
              >
                Cancel
              </button>
              <button
                style={{
                  background: "#551FFF",
                  padding: "8px",
                  width: "130px",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={submit}
                className="btn primary"
              >
                Send
              </button>
            </Box>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default Setting;
